import Table from '@/components/Table/Table.jsx'
import TableChooseProduct from '../_PRODUCT/TableChooseProduct.jsx'

export default function TableChooseDo(props) {
    const columns = [
        {
            title: '项目编号',
            dataIndex: 'prjNo',
            component: <Table.ViewText />,
        },

        {
            title: '分析域',
            dataIndex: 'amNamePath',
            component: <Table.ViewText />,
        },

        {
            title: '维度对象代码',
            dataIndex: 'doNo',
            component: <Table.ViewText />,
        },

        {
            title: '维度对象名称',
            dataIndex: 'doName',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseProduct
            columns={columns}
            {...props}
        />
    )
}
